import React from 'react';
import { Heading, Copy } from '@grubhubprod/gh-cookbook-react';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
};

export const PageSectionTitle: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
}) => {
  return (
    <>
      <Heading variant="h4">{title}</Heading>
      {subtitle && <Copy variant="body">{subtitle}</Copy>}
    </>
  );
};
